<h2 style="color:white; background-color: #242a33; text-align: center;" i18n="@@publicDashboardTitle"> Informe público EDA</h2>
<!-- <img src="assets/images/logos/logo.png" alt="logo icono" class="dark-logo w-75" /> -->
<!-- Light Logo icon -->
